import { CHRIST_PRODUCTS } from "../data/christProducts";
import { OFFICINA_CATEGORIES } from "../data/officinaCategories";

// Divisioni mostrate sulle schede lavoro (allineate al backend realizzazioni.py)
export const PROJECT_DIVISIONS = ["Autolavaggio Christ", "Autoriparatore", "Scaffalature industriali", "Depurazione acque", "Coperture esterne", "Impianti industriali"];

// Tipi di cliente (scelta dall'elenco oppure valore personalizzato)
export const CLIENT_TYPES = ["Concessionaria", "Officina meccanica", "Carrozzeria", "Gommista", "Centro revisione", "Stazione di servizio / Autolavaggio", "Azienda di trasporto / Flotta", "Officina camion", "Industria", "Ente pubblico", "Altro"];

export const GROUP_LABEL = { christ: "Autolavaggio Christ", officina: "Autoriparatore" };

// Catalogo prodotti selezionabili come "Prodotto installato": schede statiche + prodotti aggiunti dal pannello.
export const productOptions = (products = {}) => {
    const statics = [
        ...CHRIST_PRODUCTS.map((p) => ({ key: p.key, name: p.name, group: "christ" })),
        ...OFFICINA_CATEGORIES.map((c) => ({ key: c.key, name: c.title, group: "officina" })),
    ];
    const custom = Object.values(products)
        .filter((d) => d.custom)
        .map((d) => ({ key: d.key, name: d.name, group: d.group }));
    return [...statics, ...custom].filter((p) => !products[p.key]?.hidden);
};

// Link alla scheda prodotto sul sito (apre direttamente la scheda tramite ?scheda=)
export const productSheetHref = (ref) => `/?scheda=${encodeURIComponent(ref.key)}#${ref.group === "officina" ? "autoriparatore" : "schede-christ"}`;
